export default {
      id: "arrowRight-usage",
      viewBox: "0 0 100 100",
      url: "../../assets/" + "sprite.svg#arrowRight-usage",
      toString: function () {
        return this.url;
      }
    }